import React, {useContext} from 'react';
import {OrdersSadanContext} from "../OrdersSadanContext";
import {formatToPersianAddComma, parseToEnRemoveComma} from "../../../utils/CommaSeparator";

const SendPrice = () => {
  const helper = useContext(OrdersSadanContext);
  const setData = helper.setData
  const data = helper.data

  return (
    <div className="div__group__input_select mx-2">
      <label htmlFor={"rnd1"}>
        هزینه ارسال
      </label>
      <input
        type="string"
        name="sendPrice"
        value={data.sendPrice ? formatToPersianAddComma(data.sendPrice) : formatToPersianAddComma("0")}
        onChange={(e) => setData({sendPrice: parseToEnRemoveComma(e.target.value)})}
      />

    </div>
  );
};

export default SendPrice;